import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ThankYou = () => {
  const navigate = useNavigate();
  const [counter, setCounter] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCounter((prev) => prev - 1);
    }, 1000);

    const redirect = setTimeout(() => {
      navigate("/");
    }, 10000); // redirect after 10 seconds

    return () => {
      clearInterval(timer);
      clearTimeout(redirect);
    };
  }, [navigate]);

  return (
    <div className="container d-flex align-items-center justify-content-center vh-100">
      <div className="text-center">
        <img
          src="https://cdn-icons-png.flaticon.com/512/190/190411.png"
          alt="Thank You"
          className="img-fluid mb-4"
          style={{ maxWidth: "150px" }}
        />
        <h2 className="mb-3">Thank You!</h2>
        <p className="mb-2">
          We’ve received your message and will get back to you shortly.
        </p>
        <p className="text-muted mb-4">
          You will be redirected in <strong>{counter}</strong> second
          {counter !== 1 ? "s" : ""}.
        </p>
        <button className="btn btn-primary" onClick={() => navigate("/")}>
          Go to Homepage Now
        </button>
      </div>
    </div>
  );
};

export default ThankYou;
